
export const lang = {
    "email":"E-mail",
    "phone":"Telefon",
    "address":"Adresa",
    "in":"IČO",
    "tin":"DIČ",
    "acc":"Číslo účtu",
    "office":"Pobočka",
    "b2x":"Jsme tu pro vás",
    "b2c":"Domácnosti",
    "b2b":"Firmy",
    "desc":"Popis",
    "price":"Cena",
    "unit":"Jednotka",
    "charge":"Příplatek",
    "pricePU":"Cena za ks",
    "currency":"Kč",
    "info":"nápověda"
}



export default lang;